import map from './map';
import marker from './marker';
import alertLogin from './alert-login';
import { setDelFavorite, setNewFavorite } from './common-offline';
import heart_ from '../img/btn_heart32_.png';
import heart from '../img/btn_heart32.png';
import { markUnSelect } from '../img/pin';
import { numberWithCommas } from './api/common';
import center from './center';
import { getClientID } from '../../../../assets/js/common-es6';

const clientID = getClientID();
const querySelector = document.querySelector.bind(document);
// const sideBar = querySelector('.js-list__center');
const sideBar = null;
const scrollbar = querySelector('.js-list__scrollbar');
const rowTemplate = querySelector('.list__item--template');
const loader = document.getElementById('loader');

let centerPopup = '';

const CenterList = {
  showEmptyNotice: () => {
    if (sideBar) {
      sideBar.innerHTML = '';
    }

    const emptyElement = document.createElement('p');
    emptyElement.innerHTML = '선택한 조건에 맞는 정보가 없습니다.<br>위치 또는 키워드를 변경하여 다시 검색하세요.';
    emptyElement.classList.add('empty-list-child');

    if (sideBar) {
      sideBar.appendChild(emptyElement);
    }
  },
  wrapWithElement: (targetElement, wrapElementName) => {
    const wrapper = document.createElement(wrapElementName);

    if (targetElement) {
      wrapper.appendChild(targetElement);
    }

    return wrapper;
  },
  getDistanceFromMap: ({ mapY, mapX }) => {
    const positionOfMap = map.getCenter();
    const positionOfCenter = new N.LatLng(mapY, mapX);

    return Math.floor(map.getProjection().getDistance(positionOfMap, positionOfCenter));
  },
  onEnterItemCard: (idx) => {
    return (() => {
      const thisMarker = marker.markers[idx];
      thisMarker.isNotScroll = true;

      thisMarker.trigger('click', thisMarker);
    });
  },
  onClickItemCardCenter: (center) => {
    return (() => {
      const offlineCenterDetailPopup = document.getElementsByClassName('offline-center-detail-popup')[0];

      if (!offlineCenterDetailPopup) return false;

      if (offlineCenterDetailPopup.classList.contains('is-active-detail-popup') && centerPopup === center.id) {
        offlineCenterDetailPopup.style.display = 'none';
        offlineCenterDetailPopup.classList.remove('is-active-detail-popup');
      } else {
        centerPopup = center.id;
        offlineCenterDetailPopup.style.display = 'block';
        offlineCenterDetailPopup.classList.add('is-active-detail-popup');
      }
    });
  },
  onClickHeart: (targetCenter, favoriteEL) => {
    return (() => {
      const infoWindowFavorite = document.querySelector('.marker__infoWindow--heart-button');

      if (!clientID) {
        alertLogin();
        return;
      }

      if (targetCenter.favorite === 0) {
        setNewFavorite(clientID, targetCenter.id, (status, res) => {
          if (status) {
            favoriteEL.src = heart_;
            infoWindowFavorite.src = heart_;
            targetCenter.favorite = res.id;
          }
        });
      } else {
        setDelFavorite(targetCenter.favorite, (status) => {
          if (status) {
            favoriteEL.src = heart;
            infoWindowFavorite.src = heart;
            targetCenter.favorite = 0;
          }
        });
      }
    });
  },
  createListRow: (thisCenter, idx) => {
    const row = rowTemplate.cloneNode(true);
    row.classList.remove('list__item--template');
    row.classList.add('list__item');
    row.hidden = false;

    const rowWrapper = CenterList.wrapWithElement(row, 'LI');
    rowWrapper.onClick = () => { CenterList.onEnterItemCard(idx); };

    const distance = CenterList.getDistanceFromMap(thisCenter);

    const rowQuerySelector = row.querySelector.bind(row);

    const rowTitle = rowQuerySelector('.offline-center-box__title-text');
    const rowType = rowQuerySelector('.offline-center-box__type');
    const rowAddress = rowQuerySelector('.offline-center-box__road-address');
    const rowCode = rowQuerySelector('.offline-center-box__icon');
    // const rowFavorite = rowQuerySelector('.list__item--bookmark');
    const rowDistance = rowQuerySelector('.offline-center-box__distance');
    const rowCenterWrapper = rowQuerySelector('.offline-center-list-box');
    const rowCenterPhone = rowQuerySelector('.offline-center-box__telephone-number');

    rowTitle.textContent = thisCenter.title;
    rowType.textContent = thisCenter.type;
    rowAddress.textContent = thisCenter.searchAddress;
    rowCode.style.backgroundImage = `url("${markUnSelect}")`;
    rowCode.style.backgroundSize = '100% 100%';
    rowCode.setAttribute('id', thisCenter.id);
    // rowFavorite.src = thisCenter.favorite === 0 ? heart : heart_;
    // rowFavorite.onclick = this.onClickHeart(thisCenter, rowFavorite);
    rowDistance.textContent = `${numberWithCommas(distance)}m`;
    rowCenterWrapper.onclick = CenterList.onClickItemCardCenter(thisCenter);
    rowCenterPhone.textContent = thisCenter.telephone;

    if (sideBar) {
      sideBar.appendChild(rowWrapper);
    }
  },
  hideLoader: () => {
    loader.style.display = 'none';
  },
  loadCenterList: (centerList = []) => {
    if (sideBar) {
      sideBar.innerHTML = '';
    }

    const boundCenters = centerList || center.getBoundCenter();

    if (rowTemplate) {
      for (let idx = 0, len = center.centers.length; idx < len; idx += 1) {
        const thisCenter = boundCenters[idx];

        if (thisCenter) {
          // this.createListRow(thisCenter, idx);
        }
      }

      scrollbar.scrollTop = 0;
    }

    CenterList.hideLoader();
  },
};

export default CenterList;
